import {
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import React from "react";
import { Link } from "react-router-dom";
import YoozSvgIcon from "../components/yooz_svg_icon";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100%",
    maxWidth: 400,
    width: 200,
    backgroundColor: theme.palette.background.paper,
  },

  selected: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    backgroundColor: `#C0E8F8 !important`,
  },

  listHeader: {
    backgroundColor: theme.palette.secondary.main,
    padding: 0,
    color: "#FFF",
  },

  yoozLogo: {
    height: "100%",
  },
}));

export default function SelectableNavList(props) {
  const classes = useStyles();
  const { value, setValue, toggleDrawer, routes } = props;
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  const handleListItemClick = (event, index) => {
    setValue(index);
    window.scrollTo(0, 0);
    toggleDrawer();
  };

  return (
    <div className={classes.root}>
      <List
        component="nav"
        subheader={
          <ListSubheader
            component="div"
            id="nested-list-subheader"
            className={classes.listHeader}
          >
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                edge="start"
              >
                <MenuIcon />
              </IconButton>
              <IconButton
                edge="start"
                color="primary"
                component={Link}
                to="/"
                onClick={() => handleListItemClick(null,0)}
              >
                <YoozSvgIcon
                  height="100%"
                  width={xs ? 70 : sm ? 80 : 110}
                  color={"#FFF"}
                />
              </IconButton>
            </Toolbar>
          </ListSubheader>
        }
      >
        {routes.map((route, index) =>
          route.show ? (
            <ListItem
              button
              selected={value === index}
              onClick={(event) => handleListItemClick(event, index)}
              classes={{
                selected: classes.selected,
              }}
              component={Link}
              to={route.path}
              key={index}
            >
              <ListItemText primary={route.label} />
            </ListItem>
          ) : (
            <ListItem
              button
              selected={value === index}
              onClick={(event) => handleListItemClick(event, index)}
              classes={{
                selected: classes.selected,
              }}
              component={Link}
              to={route.path}
              key={index}
              style={{ display: "none" }}
            >
              <ListItemText primary={route.label} />
            </ListItem>
          )
        )}
      </List>
    </div>
  );
}
